module.exports = __webpack_public_path__ + "docs/img/image-placeholder.733164ac.jpg";